import React from 'react';
import { AntIcon, Loading } from './styles';
interface SpinnerProps {
	size?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 38 }: SpinnerProps) => (
	<Loading indicator={<AntIcon size={size} spin />} />
);
